import React, { Component } from 'react';
import * as Styles from './Styles';
import Button from '../../components/button/Button';
import SvgArrowLeft from '../../others/svg_dist/ArrowLeft';
import { Checkbox } from '@react_components/basic_toolkit';
import { gotoPage } from '../../utils/gotoPage';
import { Routing } from '../../core/Routing';
import { ConnectedProps, connect } from 'react-redux';
import { AppState } from '../../core/Store';
import * as DictionariesConsentsSelectors from '../../reducers/data/dictionaries/consents/selectors';
import * as FormManager from '../../reducers/ui/form';
import FormInput from '../../components/formInput/FormInput';
import Switch from '../../components/switch/Switch';

type State = {};

class SendOwuModalComponent extends Component<PropsFromRedux, State> {
	state = {};

	componentDidMount(): void {
		FormManager.Validate.validatePersonalInfoField('email');
	}

	next = (close: () => void) => {
		if (!this.props.canNext) return;

		FormManager.sendOwuMail();
		this.props.setFormAccessible(true);
		gotoPage(Routing.main.form);
		close();
	};

	render() {
		return (
			<div>
				<Styles.ConsentsInputWrapper>
					<FormInput
						label=""
						onChange={(value) =>
							FormManager.setPersonalInfoField('email', value)
						}
						placeholder="email do wysyłki"
						value={this.props.personalInfo.email || ''}
						maxWidth="90%"
						error={this.props.personalInfoErrors.email}
					/>
				</Styles.ConsentsInputWrapper>
				<Styles.Divider />
				<Styles.CheckAllContainer>
					<Switch
						isActive={this.props.allRequiredStage1ConsentsChecked}
						onClick={() => FormManager.toggleAllStep1Consents()}
					/>
					<p>
						Zaznacz <strong>wszystkie</strong> zgody i oświadczenia
					</p>
				</Styles.CheckAllContainer>
				<Styles.ConsentsContainer>
					{this.props.consentsDict.map((consent) => {
						const cState = this.props.consentsState.find(
							(el) => el.consentId === consent.consentId
						);

						return (
							<Styles.Consent key={consent.consentId}>
								<Checkbox
									checked={cState?.consentState || false}
									onChange={() =>
										FormManager.flipConsent(
											consent.consentId,
											'step1'
										)
									}
									label={
										<>
											<span
												style={{
													textTransform: 'none',
													fontSize: '12px',
												}}
												dangerouslySetInnerHTML={{
													__html: consent.consentContent,
												}}
											/>
											<Styles.Reqstart>
												{consent.consentRequire && '* '}
											</Styles.Reqstart>
										</>
									}
								/>
							</Styles.Consent>
						);
					})}
				</Styles.ConsentsContainer>
				<Styles.ConsentsNoticeFont>
					Oświadczenia oznaczone (<span>*</span>) są obowiązkowe.
				</Styles.ConsentsNoticeFont>
				<Styles.ButtonsContainer>
					<Button
						Icon={<></>}
						label="wstecz"
						onClick={this.props.closeFn}
						style={{
							height: '35px',
							width: '40%',
							margin: '0 5px',
						}}
					/>
					<Button
						Icon={<SvgArrowLeft />}
						label="dalej"
						onClick={() => this.next(this.props.closeFn)}
						style={{
							height: '35px',
							width: '40%',
							margin: '0 5px',
							opacity: !this.props.canNext ? '0.3' : '1',
							cursor: !this.props.canNext
								? 'not-allowed'
								: 'pointer',
						}}
					/>
				</Styles.ButtonsContainer>
			</div>
		);
	}
}

interface Own {
	closeFn: () => void;
}

const connector = connect(
	(state: AppState, own: Own) => {
		const personalInfoErrors =
			FormManager.Selectors.getPersonalInfoErrors(state);
		const allRequiredStage1ConsentsChecked =
			FormManager.Selectors.getAllRequiredStage1ConsentsChecked(state);

		return {
			consentsDict:
				DictionariesConsentsSelectors.getConsentsStage1(state),
			consentsState: FormManager.Selectors.getConsentsStep1(state),
			personalInfo: FormManager.Selectors.getPersonalInfo(state),
			personalInfoErrors,
			allRequiredStage1ConsentsChecked,
			canNext:
				!personalInfoErrors.email && allRequiredStage1ConsentsChecked,
		};
	},
	(dispatch) => ({
		setFormAccessible: (accessible: boolean) =>
			dispatch(FormManager.Actions.setFormAccessible(accessible)),
	})
);

export type PropsFromRedux = ConnectedProps<typeof connector> & Own;

const SendOwuModal = connector(SendOwuModalComponent);
export default SendOwuModal;
